import React, { useCallback, useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Dialog } from "../../components/Hooks/Dialog/DialogProvider";
import PopupDialog from "../../components/Form/PopupDialog";
import { CircularProgress } from "@mui/material";
import { ControllerAPI } from "../../api/api";
import { hasFailed } from "@miragon/react-utils-api";

interface Props {
    workerId: string;
}

const useStyles = makeStyles({
    paper: {
        maxWidth: "1200px"
    },
    loadingWrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "1rem"
    },
    error: {
        color: "red",
        margin: "1rem"
    },
    screenshot: {
        width: "100%",
        height: "auto",
        maxHeight: "80%",
        objectFit: "contain"
    }
});

const WorkerScreenshotDialog: Dialog<void, Props> = props => {
    const classes = useStyles();

    const {
        workerId,
        onAccept
    } = props;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>();
    const [data, setData] = useState<string>();
    const [key, setKey] = useState(0);

    useEffect(() => {
        (async () => {
            setLoading(true);
            const response = await ControllerAPI.requestWorkerScreenshot(workerId);
            if (hasFailed(response)) {
                setError(response.error);
                setLoading(false);
                return;
            }

            const response2 = await ControllerAPI.loadWorkerScreenshot(workerId);
            setLoading(false);
            if (hasFailed(response2)) {
                setError(response2.error);
                return;
            } else {
                if (response2.result === "") {
                    setError("Timeout");
                    return;
                }
                setData("data:image/png;base64," + response2.result);
            }
        })();
    }, [workerId, key]);

    const onRefresh = useCallback(() => {
        setError(undefined);
        setData(undefined);
        setLoading(false);
        setKey(cur => cur + 1);
    }, []);

    return (
        <PopupDialog
            open
            paperClassName={classes.paper}
            onFirst={onAccept}
            onSecond={onRefresh}
            firstTitle="Schließen"
            secondTitle="Aktualisieren"
            title="Screenshot abfragen">

            {loading && (
                <div className={classes.loadingWrapper}>
                    <CircularProgress disableShrink />
                    <br />
                    Screenshot wird abgerufen...
                </div>
            )}

            {error && (
                <p className={classes.error}>
                    Screenshot konnte nicht abgerufen werden: {error}
                </p>
            )}

            {!loading && data && (
                <img src={data} alt="Screenshot" className={classes.screenshot} />
            )}

        </PopupDialog>
    );
};

export default WorkerScreenshotDialog;
